module.exports = __webpack_public_path__ + "img/ennetix-setting-page-security-tab.377467cc.png";